<script>
export default {
  name: "UserIntegral",
  data() {
    return {
      integral: this.$store.state.user.user.member.integral
    }
  },
  methods: {
    getDetail() {
      this.$router.push('/personal-center/points-detailsViews');
    }
  }
};
</script>

<template>
  <div class="user-integral" @click="getDetail">
    <img class="icon" src="@/assets/h-icons/integral.svg">
    <div class="value">{{ integral }}</div>
    <div class="label">积分</div>
  </div>
</template>

<style lang="scss" scoped>
.user-integral {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  border: 1px solid #d1d1d2;
  border-radius: 13.5px;
  height: 26px;
  padding: 0 10px;
  user-select: none;
  cursor: pointer;
  font-size: 14px;

  &:hover{
    border-color: #b8b8b9;
  }

  .icon {
    width: 1em;
    height: 1em;
  }

  .value {
    color: #d4062e;
  }

  .label {
    color: #555556;
  }
}
</style>
